// RegisterLoading.jsx
import React from 'react';
import { UserPlus, ChevronRight, Cpu, BarChart, DollarSign } from 'lucide-react';

const RegisterLoading = () => {
  return (
    <div className="register-loading-overlay">
      <div className="register-loading-container">
        <div className="register-animation">
          <div className="register-steps">
            <div className="step active">
              <div className="step-indicator">
                <UserPlus size={20} />
              </div>
              <div className="step-line"></div>
            </div>
            <div className="step">
              <div className="step-indicator">
                <Cpu size={20} />
              </div>
              <div className="step-line"></div>
            </div>
            <div className="step">
              <div className="step-indicator">
                <BarChart size={20} />
              </div>
              <div className="step-line"></div>
            </div>
            <div className="step">
              <div className="step-indicator">
                <DollarSign size={20} />
              </div>
            </div>
          </div>
          <div className="data-particles">
            <div className="data-particle"></div>
            <div className="data-particle"></div>
            <div className="data-particle"></div>
            <div className="data-particle"></div>
            <div className="data-particle"></div>
            <div className="data-particle"></div>
            <div className="data-particle"></div>
            <div className="data-particle"></div>
          </div>
        </div>
        <p className="register-loading-text">Creating your mining account</p>
        <div className="register-status">
          <span className="status-item">Verifying information</span>
          <span className="status-item">Setting up wallet</span>
          <span className="status-item">Connecting to miners</span>
        </div>
      </div>

      <style jsx>{`
        .register-loading-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(17, 24, 39, 0.9);
          backdrop-filter: blur(10px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }
        
        .register-loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          background: linear-gradient(135deg, rgba(31, 41, 55, 0.9) 0%, rgba(17, 24, 39, 0.95) 100%);
          padding: 40px;
          border-radius: 24px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.3);
          border: 1px solid rgba(255, 255, 255, 0.05);
          max-width: 400px;
          width: 90%;
        }
        
        .register-animation {
          width: 100%;
          position: relative;
          height: 100px;
          margin-bottom: 24px;
        }
        
        .register-steps {
          display: flex;
          justify-content: space-between;
          width: 100%;
          position: relative;
          z-index: 2;
        }
        
        .step {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          flex: 1;
        }
        
        .step-indicator {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(31, 41, 55, 0.8);
          border: 2px solid #4F46E5;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #9CA3AF;
          position: relative;
          z-index: 2;
          transition: all 0.5s ease;
        }
        
        .step.active .step-indicator {
          background: #4F46E5;
          color: white;
          box-shadow: 0 0 15px 0 rgba(79, 70, 229, 0.5);
        }
        
        .step-line {
          position: absolute;
          top: 20px;
          right: -50%;
          width: 100%;
          height: 2px;
          background: rgba(79, 70, 229, 0.3);
          z-index: 1;
        }
        
        .step:last-child .step-line {
          display: none;
        }
        
        .step.active .step-line {
          background: #4F46E5;
        }
        
        .data-particles {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
        }
        
        .data-particle {
          position: absolute;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #6366F1;
          opacity: 0;
        }
        
        .data-particle:nth-child(1) {
          top: 20%;
          left: 10%;
          animation: particle-move 3s infinite linear 0.1s;
        }
        
        .data-particle:nth-child(2) {
          top: 60%;
          left: 15%;
          animation: particle-move 3s infinite linear 0.7s;
        }
        
        .data-particle:nth-child(3) {
          top: 30%;
          left: 35%;
          animation: particle-move 3s infinite linear 0.3s;
        }
        
        .data-particle:nth-child(4) {
          top: 70%;
          left: 45%;
          animation: particle-move 3s infinite linear 1.1s;
        }
        
        .data-particle:nth-child(5) {
          top: 40%;
          left: 60%;
          animation: particle-move 3s infinite linear 0.5s;
        }
        
        .data-particle:nth-child(6) {
          top: 20%;
          left: 75%;
          animation: particle-move 3s infinite linear 0.9s;
        }
        
        .data-particle:nth-child(7) {
          top: 60%;
          left: 85%;
          animation: particle-move 3s infinite linear 0.2s;
        }
        
        .data-particle:nth-child(8) {
          top: 30%;
          left: 90%;
          animation: particle-move 3s infinite linear 0.6s;
        }
        
        .register-loading-text {
          font-size: 18px;
          font-weight: 600;
          color: white;
          margin-bottom: 16px;
          text-align: center;
        }
        
        .register-status {
          display: flex;
          flex-direction: column;
          width: 100%;
          gap: 8px;
        }
        
        .status-item {
          display: flex;
          align-items: center;
          color: #9CA3AF;
          font-size: 14px;
          animation: status-fade 6s infinite;
          opacity: 0;
        }
        
        .status-item:nth-child(1) {
          animation-delay: 0s;
        }
        
        .status-item:nth-child(2) {
          animation-delay: 2s;
        }
        
        .status-item:nth-child(3) {
          animation-delay: 4s;
        }
        
        .status-item:before {
          content: '';
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: #4F46E5;
          margin-right: 8px;
          animation: pulse 1s infinite;
        }
        
        @keyframes particle-move {
          0% {
            transform: translateX(0) translateY(0);
            opacity: 0;
          }
          30% {
            opacity: 0.8;
          }
          70% {
            opacity: 0.8;
          }
          100% {
            transform: translateX(40px) translateY(0);
            opacity: 0;
          }
        }
        
        @keyframes status-fade {
          0%, 100% {
            opacity: 0;
          }
          16.67%, 83.33% {
            opacity: 1;
          }
        }
        
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.5);
            opacity: 0.6;
          }
        }
      `}</style>
    </div>
  );
};

export default RegisterLoading;
